// UI-facing state of the running match: pause menu, pointer lock, chosen loadout. The session
// writes these signals; the overlay in ui/screens/Game.tsx reads them.

import { signal } from "@preact/signals";

/** The pause menu is open (the match keeps running, the player stands still). */
export const gamePaused = signal(false);
/** The canvas holds the pointer lock. */
export const pointerLocked = signal(false);
/** A match is on screen (status "playing"): the overlay only renders then. */
export const matchActive = signal(false);
/** What the pause overlay shows: the pause menu, or the lobby panel of a custom lobby. */
export const pauseView = signal<"menu" | "lobby">("menu");
/** Loadout slot picked for the next spawn, null until the player picks one this match. */
export const nextLoadout = signal<number | null>(null);

export interface PauseActions {
  resume(): void;
  selectLoadout(index: number): void;
}

let actions: PauseActions | null = null;

export function registerPauseActions(a: PauseActions | null): void {
  actions = a;
}

export function resumeGame(): void {
  actions?.resume();
}

export function chooseLoadout(index: number): void {
  actions?.selectLoadout(index);
}
